import { language as lan_navigationConfig } from "./store-product-setting-navigation-config";
import { language as lan_product } from "./product/product";
import { language as lan_design } from "./design/design";
import { language as lan_mockup } from "./mockup/mockup";
import { language as lan_info } from "./info/info";
import { language as lan_pricing } from "./pricing/index";
import { language as lan_binding } from "./binding/binding";
import { language as lan_uoload_list } from "./file-upload-list-config";

let language = {
    // 步骤导航
    ...lan_navigationConfig,
    // 产品详细
    ...lan_product,
    // 产品定制
    ...lan_design,
    // 产品图片
    ...lan_mockup,
    // 产品xinxi
    ...lan_info,
    // 产品价格
    ...lan_pricing,
    //绑定产品
    ...lan_binding,
    ...lan_uoload_list,

    // 底部操作按钮
    STORE_PRODUCT_SETTING_BACK_BTN: "BACK",
    STORE_PRODUCT_SETTING_BACK_PRODUCT_BTN: "BACK TO PRODUCT",
    STORE_PRODUCT_SETTING_GO_INFO_BTN: "Proceed to info",
    STORE_PRODUCT_SETTING_GO_DESIGN_BTN: "GO DESIGN",
    STORE_PRODUCT_SETTING_GO_CARD_RARITY_BTN: "PROCEED TO CARD RARITY",
    STORE_PRODUCT_SETTING_BACK_CARD_RARITY_BTN: "BACK TO CARD RARITY",
    STORE_PRODUCT_SETTING_GO_MOCKUP_BTN: "Proceed to mockups",
    STORE_PRODUCT_SETTING_PROCEED_DESIGN_BTN: "Proceed to design",
    STORE_PRODUCT_SETTING_GO_PRICING_BTN: "Proceed to pricing",
    STORE_PRODUCT_SETTING_SAVE_PRODUCT_BTN: "SAVE PRODUCT",
    STORE_PRODUCT_SETTING_UPDATE_PRODUCT_BTN: "UPDATE PRODUCT",
    STORE_PRODUCT_SETTING_SAVE_BTN: "SAVE"
};

export { language }